import React from "react";
import useStyle from "./useStyle";
import { Link } from "react-router-dom";
import cssUtils from "utils/cssUtils";

export interface PrimaryButtonProps {
  title: string;
  disabled?: boolean;
  onClick?: () => void;
  to?: string;
  className?: string | undefined;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = function(props) {
  const classes = useStyle(props);

  if (props.to != null) {
    return (
      <Link
        className={cssUtils.join(props.className, classes.button)}
        to={props.to}
        onClick={() => !props.disabled && props.onClick && props.onClick()}
      >
        <span className={classes.title}>{props.title}</span>
      </Link>
    );
  } else {
    return (
      <button
        className={cssUtils.join(props.className, classes.button)}
        onClick={() => !props.disabled && props.onClick && props.onClick()}
      >
        <span className={classes.title}>{props.title}</span>
      </button>
    );
  }
};

export default PrimaryButton;
